<template>
  <div id="MarkForm">
    <div>
      <h5 style="margin: 0; font-size: 32px; line-height: 60px">信息填报</h5>
    </div>
    <!-- <div class="m-2 text-left lh-2">
      <van-notice-bar
        wrapable
        :scrollable="false"
        color="#1989fa"
        background="#ecf9ff"
        text="仅用于入场身份核对、劳务费发放。请于1月15日18:00前完成信息填报。"
      />
    </div> -->
    <!-- <p>{{$route.params.woid}}</p>
    <p>{{$route.params.oid}}</p>-->
    <el-form label-position="left" class="m-4 text-left">
      <!-- 选择考试 -->
      <el-form-item label-width="30%" size="mini" v-show="false">
        <template slot="label">
          <i class="fa fa-fw fa-bars"></i>
          考试
        </template>
        <el-select
          v-model="workID"
          filterable
          placeholder="请选择申请考试工作"
          style="width: 100%"
          disabled
        >
          <el-option
            v-for="(item, index) in workList"
            :key="index"
            :label="item.WorkName"
            :value="item.WorkID"
          ></el-option>
        </el-select>
        <small class="color-gray mt-2"></small>
      </el-form-item>
      <!-- 选择机构 -->
      <el-form-item label-width="30%" size="mini" v-show="false">
        <template slot="label">
          <i class="fa fa-fw fa-bars"></i>
          机构
        </template>
        <el-select
          v-model="organID"
          filterable
          placeholder="请选择申请的机构"
          style="width: 100%"
          disabled
        >
          <el-option
            v-for="(item, index) in organList"
            :key="index"
            :label="item.OrganName"
            :value="item.OrganID"
          ></el-option>
        </el-select>
        <small class="color-gray mt-2"></small>
      </el-form-item>
      <!-- 个人照片 -->
      <template v-if="workID != '' && organID != ''">
        <div v-if="false">
          <div class="user-photo">
            <el-upload
              class="avatar-uploader"
              :action="getUserPhotoUpdateUrl()"
              :show-file-list="false"
              :data="fileParam"
              :on-success="handleAvatarSuccess"
              :on-progress="handleProgress"
              :before-upload="beforeAvatarUpload"
              :on-error="errorHandler"
            >
              <p>个人真实照片</p>
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <p>证件照片上传,请确保真实有效</p>
            </el-upload>
          </div>
        </div>
      </template>
      <!-- 申请当前考试所需填写内容 -->
      <template>
        <van-notice-bar mode="closeable" class="mb-4">
          <small>
            标记红色
            <i class="fa fa-fw fa-tag color-red"></i>
            的内容为必填报字段,请认真填写。
          </small>
        </van-notice-bar>
      </template>
      <el-form-item
        :label-width="item.CHSName.length > 4 ? 'auto' : '30%'"
        size="mini"
        v-for="(item, index) in userInfo.UserContent"
        :key="index"
        :ref="item.FieldName"
      >
        <!-- 验证表单项显示条件判断结果 -->
        <template>
          <template slot="label">
            <i class="fa fa-fw fa-tag color-red" v-if="item.Required == 1"></i>
            <i class="fa fa-fw fa-tag" v-else></i>
            {{ item.CHSName }}
          </template>
          <!-- 通用字段处理方式 -->
          <template>
            <el-input
              v-model="item.Value"
              :placeholder="item.Memo || '请填写'"
              v-if="item.SubData == 0"
            >
              <!-- 身份证号查询按钮，根据身份证号查询个人已填写信息 -->
              <!-- <el-button
            v-if="item.FieldName == 'UserPIN'"
            slot="append"
            icon="el-icon-search"
            @click="queryUserPIN(item.Value)"
              ></el-button>-->
            </el-input>
            <el-select
              v-model="item.Value"
              filterable
              :placeholder="item.Memo || '请选择'"
              style="width: 100%"
              v-else
            >
              <el-option
                v-for="(element, i) in subDataArray[item.FieldName]"
                :key="i"
                :label="element.Name"
                :value="element.Value"
              ></el-option>
            </el-select>
          </template>
          <small class="color-gray mt-2"></small>
        </template>
      </el-form-item>

      <!-- 提交按钮 -->
      <el-form-item>
        <el-button type="primary" class="w-100" @click="updateBtn" round
          >保存信息</el-button
        >
      </el-form-item>

      <el-dialog :visible.sync="outerVisible" width="90%">
        <template slot="title">保密承诺书</template>
        <div>
          <p class="text-indent">
            本人参加广东省2021年度选调优秀大学毕业生省直机关及其直属机构面试工作，自愿遵守《中华人民共和国保守国家秘密法》以及其他保密规定。根据面试工作纪律的要求，为做好保密工作，特作以下承诺：
          </p>
          <p class="text-indent">
            一、认真遵守公务员面试保密纪律，履行保密义务；
          </p>
          <p class="text-indent">
            二、不违规记录、存储、复制、携带公务员面试试题等信息，不违规持有面试试题信息载体；
          </p>
          <p class="text-indent">
            三、不以任何方式泄密所接触的公务员面试信息；
          </p>
          <p class="text-indent">四、不隐瞒本人应报告的重大事项；</p>
          <p class="text-indent">
            五、未经省级公务员主管部门审查批准，不擅自发表涉及未公开工作内容的文章、著述。
          </p>
          <p class="text-indent">
            上述所有条款本人已仔细阅读，明白无误，无任何异议。如果本人泄露有关机密，愿意接受有关法律责任的追究。
          </p>
          <p class="ls-1 text-right text-bold" v-if="userInfo.UserContent">
            {{ userInfo.UserContent[0].Value }}
          </p>
          <p class="ls-1 text-right text-bold">
            {{ formatCHSDate(getDateTime()) }}
          </p>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button
            type="text danger"
            class="color-red"
            style=""
            @click="confirmBtn"
            >已阅读，确认</el-button
          >
        </div>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
Array.from(document.getElementsByClassName("el-select")).forEach((item) => {
  item.children[0].children[0].removeAttribute("readOnly");
  item.children[0].children[0].onblur = function () {
    let _this = this;
    setTimeout(() => {
      _this.removeAttribute("readOnly");
    }, 200);
  };
});
// 引入 image-conversion
import * as imageConversion from "image-conversion";
// import fileUtil from "@/utils/fileUtil";
export default {
  name: "MarkForm",
  data () {
    return {
      guid: "wechatOpenIDorGuid",
      fileList: [],
      fileParam: {},
      imageUrl: "",
      workID: "",
      workList: [],
      organID: "",
      organList: [],
      userInfo: {},
      subDataArray: [],
      outerVisible: false
    };
  },
  watch: {
    workID: function () {
      this.getUserInfo();
    },
    organID: function () {
      this.getUserInfo();
    },
    "userInfo.UserContent": {
      handler: function (newVal, oldVal) {
        // eslint-disable-next-line no-console
        console.log("监听表单数组变化", newVal, oldVal);
      },
      deep: true,
    },
  },
  methods: {
    errorHandler (err, file, fileList) {
      // eslint-disable-next-line no-console
      console.log("上传文件出错。", err, file, fileList);
      return true;
    },
    //upload组件上传成功后回调事件
    handleAvatarSuccess (res, file) {
      // eslint-disable-next-line no-console
      console.log("res", res);
      if (res.code == 20000) {
        this.$notify({ type: "success", message: "照片上传成功。" });
        this.imageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$toast(res.message);
      }
    },
    handleProgress (event, file, fileList) {
      // eslint-disable-next-line no-console
      console.log('上传进度', event, file, fileList)
    },
    //upload组件验证数据内容
    beforeAvatarUpload (file) {
      //图片校验
      const isJPG = file.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        return isJPG;
      }
      // 主要通知
      // eslint-disable-next-line no-console
      console.log("弹出文件上传提示");
      this.$notify({ type: "success", message: "照片正在上传..." });
      // 判断图片文件是否需要压缩（图片不大于4m,宽度不大于2000）
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let isLt2M = file.size / 1024 / 1024 > 4; // 判定图片大小是否小于4MB
        // 这里需要计算出图片的长宽
        let img = new Image();
        img.onload = function () {
          file.width = img.width; // 获取到width放在了file属性上
          file.height = img.height; // 获取到height放在了file属性上
          let valid = img.width > 2000; // 图片宽度大于2000
          // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
          if (valid || isLt2M) {
            // eslint-disable-next-line no-console
            console.log("图片处理 imageConversion", imageConversion);
            imageConversion
              .compressAccurately(file, {
                size: 400,
                width: 2000,
              })
              .then((res) => {
                // console.log(33, res)
                resolve(res);
              });
          } else resolve(file);
        };
        // 需要把图片赋值
        img.src = _URL.createObjectURL(file);
      });
    },
    //获取考试工作任务列表
    getUserWork () {
      this.apiGetUserManageWork({}, this, (res) => {
        if (res.code == 20000) {
          this.workList = res.data;
        } else {
          this.$toast(res.message);
        }
      });
    },
    //获取工作数据用户机构列表
    GetUserAddrOrganList () {
      this.apiGetUserAddrOrganList({}, this, (res) => {
        if (res.code == 20000) {
          this.organList = res.data;
        } else {
          this.$toast(res.message);
        }
      });
    },
    //获取用户信息
    getUserInfo () {
      //判断工作任务和机构是否已选，未选时不能有效获取用户信息
      if (this.workID != "" && this.organID != "") {
        this.apiGetUserManageInfo(
          {
            WorkID: this.workID,
            OrganID: this.organID,
            UserID: "",
            WechatOpenID: this.guid,
          },
          this,
          (res) => {
            //判断用户信息是否正确返回
            if (res.code == 20000) {
              this.userInfo = res.data;
              this.imageUrl = res.data.Photo;
              //正确获取到数据后更改文件（用户照片）上传参数
              this.fileParam = {
                WorkID: this.workID,
                OrganID: this.organID,
                WechatOpenID: this.guid,
              };
              //循环工作人员需填报字段
              res.data.UserContent.forEach((element) => {
                //判断当前字段是否存在子数据集
                if (element.SubData == 1) {
                  this.apiGetUserManageSubdataList(
                    {
                      FieldName: element.FieldName,
                    },
                    this,
                    (res) => {
                      //将子数据集内容添加到动态数组中
                      this.subDataArray[element.FieldName] = res.data;
                      this.$forceUpdate();
                    }
                  );
                }
              });
            } else {
              //获取数据过程出现问题，提示后台返回的异常信息
              this.$toast(res.message);
            }
          }
        );
      } else {
        //未选择考试工作任务和用户机构
      }
    },
    updateBtn () {
      //this.outerVisible = true
      this.confirmBtn();

    },
    confirmBtn () {
      //提交按钮处理事件,首先进行数据检查,将数据提交到服务端
      this.apiPostUserManageInfo(
        {
          WorkID: this.workID,
          WechatOpenID: this.guid,
          OrganID: this.organID,
          UserContent: this.userInfo.UserContent,
        },
        this,
        (res) => {
          if (res.code == 20000) {
            this.$toast(res.message);
          } else {
            this.$toast(res.message);
          }
          this.outerVisible = false
        }
      );
    },
    //初期开发时微信获取用户openid接口未调通，自定义此方法生成用户唯一标识码（已停用）
    newGuid () {
      var guid = "";
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
      }
      return guid;
    },
    //根据用户身份证号查询已录入信息（微信登陆测试完成，这个方法暂停用）
    queryUserPIN (value) {
      if (value != "") {
        this.apiGetUserManageInfo(
          {
            WorkID: this.workID,
            OrganID: this.organID,
            UserID: "",
            WechatOpenID: "",
            UserPIN: value,
          },
          this,
          (res) => {
            if (res.code == 20000) {
              this.guid = res.data.WechatOpenID;
              this.userInfo = res.data;
              this.imageUrl = res.data.Photo;
              //正确获取到数据后更改文件上传参数
              this.fileParam = {
                WorkID: this.workID,
                OrganID: this.organID,
                WechatOpenID: this.guid,
              };
            } else {
              this.$toast(res.message);
            }
          }
        );
      } else {
        this.$toast("查询信息需要先输入身份证号");
      }
    },
  },
  created () {
    //获取路由参数，将参数值按规则分割成workid和organid值
    if (this.$route.params.woid != "") {
      let param = this.$route.params.woid.split("-");
      this.workID = param[0];
      this.organID = param[1];
    }
    //获取路由参数，用户openid信息
    if (this.$route.params.oid) {
      this.guid = this.$route.params.oid;
    } else {
      this.$dialog.alert("获取OpenID错误.");
    }
    //获取考试工作任务信息
    this.getUserWork();
    //获取校级机构信息
    this.GetUserAddrOrganList();
  },
  mounted () { },
};
</script>

<style scoped>
.user-photo {
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: 20px auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
